import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#a4262c', marginBottom: 8 }}>Er ging iets mis</h2>
          <p style={{ fontSize: 14, color: '#605e5c', marginBottom: 20 }}>
            {this.state.error?.message || 'Onbekende fout'}
          </p>
          <button onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            style={{ padding: '10px 24px', borderRadius: 8, border: 'none', background: '#E86E1C', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
            🔄 Pagina herladen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
